import * as React from 'react';

const AuthenticityDiamond24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m14.46 6.62-.16 1.195c-.029.222-.226.397-.475.423l-1.345.142c-.64.067-.64.892 0 .96l1.345.141c.25.027.446.202.476.423l.16 1.196c.075.569 1.003.569 1.079 0l.16-1.196c.029-.221.226-.396.475-.423l1.345-.141c.64-.068.64-.893 0-.96l-1.345-.142c-.25-.026-.446-.201-.476-.423l-.16-1.196c-.075-.568-1.003-.568-1.079 0Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.16 18.619c-1.148 1.21-3.172 1.21-4.32 0l-7.113-7.494a2.566 2.566 0 0 1-.006-3.573L5.655 4.44a2.98 2.98 0 0 1 2.166-.915h8.358c.829 0 1.618.333 2.166.915l2.934 3.11a2.566 2.566 0 0 1-.006 3.574zm-3.24-.895a1.51 1.51 0 0 0 2.16 0l7.113-7.494c.483-.51.485-1.276.003-1.787l-2.934-3.11a1.5 1.5 0 0 0-1.083-.458H7.82c-.414 0-.809.167-1.083.457L3.804 8.443a1.284 1.284 0 0 0 .003 1.787z"
  }
));
AuthenticityDiamond24.Size = 24;
AuthenticityDiamond24.Title = "AuthenticityDiamond";

export { AuthenticityDiamond24 as default };
